import React from 'react'
import { Box, Container, Grid, Typography, } from '@mui/material'; 
import img20 from '../../../src/images/img20.png'
import img21 from '../../../src/images/img21.png'
import img22 from '../../../src/images/img22.png'
import img23 from '../../../src/images/img23.png'

const allcate = [
  {
    itemsimg: img20,
    itemsimgres: './img/card-item.jpg',
    textheading: 'Set up your Wallet',
    textheadthird: 'Et ligula ullamcorper malesuada proin libero nunc consequat. Sagittis aliquam malesuada bibendum arcu',
  },
  {
    itemsimg: img21,
    itemsimgres: './img/card-item.jpg',
    textheading: 'Create your Collection ',
    textheadthird: 'At in tellus integer feugiat scelerisque varius morbi enim nunc. Faucibus ornare suspendisse sed nisi lacus.',
  },
  {
    itemsimg: img22,
    itemsimgres: './img/card-item.jpg',
    textheading: 'Add your NTFs',
    textheadthird: 'Varius sit amet mattis vulputate enim nulla. Pulvinar mattis nunc sed blandit libero volutpat sed. In nulla.',
  },
  {
    itemsimg: img23,
    itemsimgres: './img/card-item.jpg',
    textheading: 'List item for Sale',
    textheadthird: 'Placerat vestibulum lectus mauris ultrices eros. Cursus vitae congue mauris rhoncus aenean vel.',
  },
]




const Createnftprocess = () => {
  return (
     
      <Box className="sell_nft">
        <Container maxWidth='xl'>
          <Typography variant='h2' fontSize='30px' fontWeight='bold'  color='#fff' textAlign='center' paddingBottom='50px'>Create and Sell Your NFTs</Typography>
          <Grid container spacing={1}>
            {allcate.map((heading, index) => (
              <Grid key={index} item lg={3} sm={6} md={3} xs={12} marginBottom='30px'>
                <Box className='malesuada'>
                  <img src={heading.itemsimg} />
                  <Box paddingY='10px'>
                    <Box>
                      <Typography fontWeight='600' fontSize='22px' color='#fff' variant='h2' paddingBottom='10px'>
                        {heading.textheading}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography fontWeight='300' variant='h6' fontSize='16px'  color='#fff'>
                        {heading.textheadthird}
                      </Typography>
                    </Box>
                  </Box>

                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
     
  )
}

export default Createnftprocess;  